import { connect, MapStateToProps } from 'react-redux';
import { Props } from './About';
import { AppState } from '../../../../types/store';
import { getStaffByPosition } from '../../../../selectors/about';

export type StateProps = Pick<Props, 'staffMembers'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> =
  state => ({
    staffMembers: getStaffByPosition(state) || [],
  });

export default connect(mapStateToProps);
